import { MutationTree } from "vuex";
import { CourseState } from "./types";

export const mutations: MutationTree<CourseState> = {};
